import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store'
import firebase from 'firebase/app'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  
  routes: [
    {
      path: '/',
      name: 'top',
      component: () => import('./views/Top.vue'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/info/About.vue'),
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('./views/info/Privacy.vue'),
    },
    {
      path: '/term',
      name: 'term',
      component: () => import('./views/info/Term.vue'),
    },
    {
      path: '/law',
      name: 'law',
      component: () => import('./views/info/Law.vue'),
    },
    {
      path: '/howto',
      name: 'howto',
      component: () => import('./views/blog/Howto.vue'),
    },
    {
      path: '/what-is-emotion',
      name: 'what-is-emotion',
      component: () => import('./views/blog/WhatIsEmotion.vue'),
    },
    {
      path: '/morningpages',
      name: 'morningpages',
      component: () => import('./views/blog/Morningpages.vue'),
    },
    {
      path: '/blog',
      name: 'blog',
      component: () => import('./views/Blog.vue'),
    },
    {
      path: '/blog/cant-write-morningpages',
      name: 'cant-write-morningpages',
      component: () => import('./views/blog/CantWriteMorningPages.vue'),
    },
    {
      path: '/blog/need-write-morningpages',
      name: 'need-write-morningpages',
      component: () => import('./views/blog/NeedWriteMorningPages.vue'),
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/statistics/:id_year/:id_month',
      name: 'statisticsMonth',
      meta: { requiresAuth: true },
      component: () => import('./views/statistics/StatisticsMonth.vue')
    },
    {
      path: '/statistics/:id_year/:id_month/:id_day',
      name: 'statisticsDay',
      meta: { requiresAuth: true },
      component: () => import('./views/statistics/StatisticsDay.vue')
    },
    {
      path: '/archive/:id_year/:id_month/',
      name: 'archiveMonth',
      meta: { requiresAuth: true },
      component: () => import('./views/archives/ArchiveMonth.vue')
    },
    {
      path: '/archive/:id_year/:id_month/:id_day',
      name: 'archive',
      meta: { requiresAuth: true },
      component: () => import('./views/archives/Archive.vue')
    },
    {
      path: '/payment',
      name: 'payment',
      meta: { requiresAuth: true },
      component: () => import('./views/Stripe.vue')
    },
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
      firebase.auth().onAuthStateChanged(function(user) {
        if (!user) {
          next({
            path: '/',
          })
        } else {
          store.commit('onAuthStateChanged', user);
          store.commit('onUserStatusChanged', user.uid ? true : false);
          next()
        }
    });
  }else{
    next()
  }
})

export default router
